export class CheckoutHelper
{
    setup()
    {
        this.handleFinalize();
    }
    
    /**
     * Handle the final checkout step submit.
     */
    handleFinalize()
    {
        addEventListener('load', () => {
            if (document.location.href.includes('metoda-de-plata'))
            {
                // add by default
                this.addEventListenerForCheckoutSubmit();

                // add event listener for 'transpcheck_inners' custom radio buttons
                let radioButtons = document.querySelectorAll('.transpcheck_inners');
                if (radioButtons != null)
                {
                    radioButtons.forEach((radioButton) => {
                        radioButton.addEventListener('click', () => {
                            this.addEventListenerForCheckoutSubmit();
                        });
                    });
                }
            }
        });
    }

    /**
     * Add a loading image to the submit button when the user clicks on it.
     */
    private addEventListenerForCheckoutSubmit()
    {
        let form = document.getElementById('checkoutstep2form');

        if (form != null)
        {
            // get the terms checkbox
            let chkTerms = document.querySelector('input[name="aszf"]') as HTMLInputElement;
            
            // get the loading image
            let imgLoading = form.querySelector('.checkout-loading');

            if (imgLoading != null && chkTerms != null)
            {
                form.addEventListener('submit', (e) =>
                {
                    if (chkTerms.checked == true)
                    {
                        imgLoading!.setAttribute('style', 'display: block;');
                    }
                });
            }
        }
    }
}

export default CheckoutHelper;